export default {
    name: 'Expenses',
    headerRow: ['EXPENSES', null, 'CURRENT', 'PSF'],
    footerRow: {
        valueCells: [
            {
                editable: false,
                styleClasses: 'font-gotham-bold font-size-10',
                getComputedValue() {
                    return {displayValue: 'TOTAL EXPENSES'}
                }
            },
            {empty: true},
            {
                editable: false,
                styleClasses: 'font-gotham-bold font-size-10',
                getComputedValue(tabs, rowIdentifier, precomputedValues) {
                    const realEstateTaxes = Math.abs(tabs['marketing-tab'].tables['expenses'].rows['real-estate-taxes'].valueCells[2].getComputedValue(tabs, 'real-estate-taxes', precomputedValues).internalValue);
                    const insurance = Math.abs(tabs['marketing-tab'].tables['expenses'].rows['insurance'].valueCells[2].getComputedValue(tabs, 'insurance', precomputedValues).internalValue);
                    const cam = Math.abs(tabs['marketing-tab'].tables['expenses'].rows['total-cam'].valueCells[2].getComputedValue(tabs, 'total-cam', precomputedValues).internalValue);
                    const mgmtFee = Math.abs(tabs['marketing-tab'].tables['expenses'].rows['management-fee'].valueCells[2].getComputedValue(tabs, 'management-fee', precomputedValues).internalValue);
                    const nonReimbursableExpenses = Math.abs(tabs['marketing-tab'].tables['expenses'].rows['non-reimbursable-expenses'].valueCells[2].getComputedValue(tabs, 'non-reimbursable-expenses', precomputedValues).internalValue);
                    const value = realEstateTaxes + insurance + cam + mgmtFee + nonReimbursableExpenses;
                    const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                    return {internalValue: value, displayValue: displayValue}
                }
            },
            { // PSF
                editable: false,
                styleClasses: 'font-gotham-bold font-size-10',
                getComputedValue(tabs, rowIdentifier, precomputedValues) {
                    const total = tabs['marketing-tab'].tables['expenses'].footerRow.valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                    const totalSpace = precomputedValues.totalSpace;
                    const value = parseFloat((total / totalSpace).toFixed(2));
                    const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2})}`;
                    return {internalValue: value, displayValue: displayValue}
                }
            },
        ]
    },
    rows: {
        'real-estate-taxes': {
            valueCells: [
                {
                    editable: false,
                    getComputedValue() {
                        return {displayValue: 'Real Estate Taxes'}
                    }
                },
                {empty: true},
                {
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = Math.round(tabs['expenses-tab'].tables['expenses'].rows['real-estate-taxes'].valueCells[2].value);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                },
                { // PSF
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const total = tabs['marketing-tab'].tables['expenses'].rows[rowIdentifier].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const totalSpace = precomputedValues.totalSpace;
                        const value = parseFloat((total / totalSpace).toFixed(2));
                        const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                },
            ]
        },
        'insurance': {
            valueCells: [
                {
                    editable: false,
                    getComputedValue() {
                        return {displayValue: 'Insurance'}
                    }
                },
                {empty: true},
                {
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = Math.round(tabs['expenses-tab'].tables['expenses'].rows['insurance'].valueCells[2].value);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                },
                { // PSF
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const total = tabs['marketing-tab'].tables['expenses'].rows[rowIdentifier].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const totalSpace = precomputedValues.totalSpace;
                        const value = parseFloat((total / totalSpace).toFixed(2));
                        const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                },
            ]
        },
        'total-cam': {
            valueCells: [
                {
                    editable: false,
                    getComputedValue() {
                        return {displayValue: 'CAM'}
                    }
                },
                {empty: true},
                {
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = Math.round(tabs['expenses-tab'].tables['expenses'].rows['total-cam'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                },
                { // PSF
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const total = tabs['marketing-tab'].tables['expenses'].rows[rowIdentifier].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const totalSpace = precomputedValues.totalSpace;
                        const value = parseFloat((total / totalSpace).toFixed(2));
                        const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                },
            ]
        },
        'management-fee': {
            valueCells: [
                {
                    editable: false,
                    getComputedValue() {
                        return {displayValue: 'Management Fee'}
                    }
                },
                {
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = tabs['expenses-tab'].tables['expenses'].rows['management-fee'].valueCells[1].getComputedValue(tabs, precomputedValues).internalValue;
                        const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value)  ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                },
                {
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = Math.round(tabs['expenses-tab'].tables['expenses'].rows['management-fee'].valueCells[2].value);
                        const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString()}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                },
                { // PSF
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const total = tabs['marketing-tab'].tables['expenses'].rows[rowIdentifier].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const totalSpace = precomputedValues.totalSpace;
                        const value = parseFloat((total / totalSpace).toFixed(2));
                        const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                },
            ]
        },
        'non-reimbursable-expenses': {
            valueCells: [
                {
                    editable: false,
                    getComputedValue() {
                        return {displayValue: 'Non-Reimbursable Expenses'}
                    }
                },
                {empty: true},
                {
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = Math.round(tabs['expenses-tab'].tables['expenses'].rows['non-reimbursable-expenses'].valueCells[2].value);
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                },
                { // PSF
                    editable: false,
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const total = tabs['marketing-tab'].tables['expenses'].rows[rowIdentifier].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const totalSpace = precomputedValues.totalSpace;
                        const value = parseFloat((total / totalSpace).toFixed(2));
                        const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                },
            ]
        },
    }
};